import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import './Common.css';
import './kidsgames.css';

const KidsGamesServices = () => {
    useEffect(() => {
        Aos.init({ duration: 1000, offset: 250 });
    });
    return (
            <div id="kids-game" className="container rounded-5">
                <div className="row kidsgames-video-container d-flex justify-content-center align-items-center">
                    <div className="col-12 col-md-12">
                        <video className="rounded-5 w-100 h-100" data-aos="zoom-in" autoPlay muted loop playsInline style={{objectFit:"cover"}}>
                            <source type="video/mp4; codecs=&quot;avc1.4D401E, mp4a.40.2&quot;" src="https://cdn.pixabay.com/video/2020/04/29/37585-414024825_large.mp4"></source>
                        </video>
                    </div>
                    
                    <div className="row kidsgames-text-container bottom-0 d-flex justify-content-start pb-5" data-aos="fade-right">
                        <div className="col-12 col-md-6">
                            <h1  className="fw-bolder ">Kids Games</h1>
                            <p className="lead fs-4 fw-bold text-white">
                                We create engaging kids' games that entertain, educate, and inspire creativity. 
                                Our games are designed to foster problem-solving, social skills, and cognitive 
                                development in children of all ages.
                                Whether it’s through physical activities, 
                                board games, or interactive digital apps, our games offer a fun mix of challenges, 
                                colorful visuals, and simple rules to keep children engaged.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default KidsGamesServices;